import React, { createContext, useState, useContext } from "react";

export const SearchContext = createContext();

export const SearchProvider = ({ children }) => {
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);

  const data = [
    { name: "Home", link: "/" },
    { name: "About Us - About Neepco", link: "/about-us/about-neepco" },
    {
      name: "About Us - Board of Directors",
      link: "/about-us/board-of-directors",
    },
    { name: "About Us - Citizen Charter", link: "/about-us/citizen-charter" },
    {
      name: "About Us - Corporate Governance",
      link: "/about-us/corporate-governance",
    },
    { name: "Power Generation", link: "/power-generation" },
    {
      name: "Power Generation - Hydro Power",
      link: "/power-generation/hydro-power",
    },
    {
      name: "Power Generation - Thermal Power",
      link: "/power-generation/thermal-power",
    },
    {
      name: "Power Generation - Solar Power",
      link: "/power-generation/solar-power",
    },
    {
      name: "Power Generation - Projects in Pipeline",
      link: "/power-generation/projects-in-pipeline",
    },
    {
      name: "Power Generation - Joint Venture",
      link: "/power-generation/joint-venture",
    },
    { name: "Power Generation - Map", link: "/power-generation/map" },
    {
      name: "Power Generation - Power Potential",
      link: "/power-generation/power-potential",
    },
    {
      name: "Sustainable Development - Environment",
      link: "/sustainable-development/environment",
    },
    {
      name: "Sustainable Development - Rehabilitation and Resettlement",
      link: "/sustainable-development/rehabilitation-and-resettlement",
    },
    {
      name: "Sustainable Development - Swachh Bharat Abhiyan",
      link: "/sustainable-development/swachh-bharat-abhiyan",
    },
    {
      name: "Photo Gallery - Swachh Bharat Abhiyan 2017-18",
      link: "/sustainable-development/swachh-bharat-abhiyan/228",
    },
    {
      name: "Photo Gallery - Swachh Bharat Abhiyan 2018-2019",
      link: "/sustainable-development/swachh-bharat-abhiyan/229",
    },
    // {
    //   name: "Sustainable Development - Swachh Bharat Abhiyan (Table)",
    //   link: "/sustainable-development/swachh-bharat-abhiyan-table/:id",
    // },
    {
      name: "Sustainable Development - CSR",
      link: "/sustainable-development/csr",
    },
    { name: "Tender - List of Tenders", link: "/tender/list-of-tenders" },
    {
      name: "Tender - Queries Posted by Bidders",
      link: "/tender/queries-posted-by-bidders",
    },
    { name: "Tender - Tenders Awarded", link: "/tender/tenders-awarded" },
    { name: "Tender - Qualified Bidders", link: "/tender/qualified-bidders" },
    { name: "Tender - Successful Bidders", link: "/tender/successful-bidders" },
    { name: "Tender - Procurement Plan", link: "/tender/procurement-plan" },
    { name: "Tender - Integrity Pact", link: "/tender/integrity-pact" },
    { name: "Tender - Archived Tender", link: "/tender/archive-tender" },
    {
      name: "Tender - List of Debarred Companies",
      link: "/tender/list-of-debarred-companies",
    },
    { name: "Investor - Equity", link: "/investors/equity" },
    { name: "Investor - Bonds", link: "/investors/bonds" },
    {
      name: "Investor - Corporate Governance Updates",
      link: "/investors/corporate-governance-updates",
    },
    {
      name: "Commercial - Tariff Petition",
      link: "/commercial/tariff-petition",
    },
    { name: "Commercial - Notices", link: "/commercial/notices" },
    {
      name: "Commercial - Commercial Activities",
      link: "/commercial/commercial-activities",
    },
    { name: "Career", link: "/career" },
    { name: "Covid-19", link: "/covid-19" },
    { name: "Contact Us", link: "/contact-us" },
    { name: "Reservoir Status", link: "/reservoir-status" },
    { name: "Reports", link: "/reports" },
    // { name: "Footer - Report by ID", link: "/reports/:id" },
    { name: "Azadi ka Amrit Mahotsav", link: "/amrit-mahotsav" },
    // { name: "Footer - Other Celebrations", link: "/other-celebrations/:id" },
    { name: "RTI", link: "/rti" },
    // { name: "Footer - RTI Detail", link: "/rti/:id" },
    // { name: "Footer - RTI Node", link: "/rti/:id/:nid" },
    { name: "Feedback", link: "/feedback" },
    { name: "Generation", link: "/generation" },
    { name: "Home - Mission Vision", link: "/mission-vision" },
    { name: "Home - Liaison Officer", link: "/liaison-officer" },
    // { name: "Home - Challenges Detail", link: "/challenges/:id" },
    // { name: "Home - Power Detail", link: "/power-generation/:type/:id" },
    { name: "Home - Video Gallery Detail", link: "/video-gallery-detail" },
    { name: "Home - Publication Detail", link: "/publication-detail" },
    // {
    //   name: "Home - Publication Detail by ID",
    //   link: "/publication-detail/:nid",
    // },
    { name: "Home - Screen Reader", link: "/screen-reader" },
    { name: "Home - Latest News", link: "/latest-news-detail" },
    { name: "Home - Announcement Detail", link: "/announcement-detail" },
    // {
    //   name: "Home - Announcement Detail by ID",
    //   link: "/announcement-detail/:id",
    // },
    { name: "Home - Photo Gallery Detail", link: "/photo-gallery-detail" },
    // { name: "Home - Photo Detail by ID", link: "/photo-gallery-detail/:nid" },
    // { name: "Home - Latest News Detail", link: "/latest-news-detail/:nid" },
    { name: "Home - Events Detail", link: "/events-detail" },
    // { name: "Home - Events Detail by ID", link: "/events-detail/:id" },
    // { name: "Reservoir Status Detail", link: "/reservoir-status/:id" },
    // { name: "Swachh Bharat Photos", link: "/swachh-bharat-photos" },
    {
      name: "Terms and Conditions",
      link: "/terms-and-conditions",
    },
    { name: "Privacy Policy", link: "/privacy-policy" },
    { name: "Copyright Policy", link: "/copyright-policy" },
    { name: "Hyperlink Policy", link: "/hyperlink-policy" },
    {
      name: "Accessibility Statement",
      link: "/accessibility-statement",
    },
    { name: "Ex-Employee Desk", link: "/ex-employee-desk" },
    { name: "MSE Startups", link: "/mse-startups" },
    { name: "Archived News", link: "/archived-news" },
    { name: "Help", link: "/help" },
    {
      name: "Contractual Vendors",
      link: "/contractual-vendors",
    },
    { name: "Offer Works", link: "/offer-works" },
    {
      name: "Bee Painting Competition",
      link: "/bee-painting-competition",
    },
    {
      name: "Guideline for Release",
      link: "/guideline-for-release",
    },
    { name: "Under Construction", link: "*" },
    { name: "Awards", link: "/awards" },
    // { name: "Footer Middle - Awards Detail by ID", link: "/awards/:id" },
    // {
    //   name: "Footer Middle - MSE Startups Detail by ID",
    //   link: "/mse-startups/:id",
    // },
    // { name: "Footer Middle - Node Detail by ID", link: "/node-detail/:id" },
    {
      name: "Performance Highlights",
      link: "/performance-highlights",
    },
    // ==================================
    {
      name: "Hydro Power - Kopili Hydro Power Station (Khps)",
      link: "/power-generation/hydro-power/64",
    },
    {
      name: "Hydro Power -  DOYANG HYDRO POWER STATION (DHPS)",
      link: "/power-generation/hydro-power/72",
    },
    {
      name: "Hydro Power - PARE HYDRO POWER STATION (PHPS)",
      link: "/power-generation/hydro-power/54",
    },
    {
      name: "Hydro Power - KAMENG HYDRO POWER STATION (KaHPS)",
      link: "/power-generation/hydro-power/65",
    },
    {
      name: "Hydro Power -  PANYOR LOWER HYDRO POWER STATION",
      link: "/power-generation/hydro-power/56",
    },
    {
      name: "Hydro Power - TUIRIAL HYDRO POWER STATION (THPS)",
      link: "/power-generation/hydro-power/57",
    },
    {
      name: "Hydro Power - NAFRA HEP",
      link: "/power-generation/hydro-power/42",
    },
    {
      name: "Hydro Power - NEW MELLING HEP",
      link: "/power-generation/hydro-power/43",
    },
    {
      name: "Hydro Power -  WAH UMIAM STAGE -III",
      link: "/power-generation/hydro-power/58",
    },
    {
      name: "Thermal Power - NAFRA HEP",
      link: "/power-generation/thermal-power/78",
    },
    {
      name: "Thermal Power - NEW MELLING HEP",
      link: "/power-generation/thermal-power/67",
    },
    {
      name: "Thermal Power -  WAH UMIAM STAGE -III",
      link: "/power-generation/thermal-power/79",
    },
    {
      name: "Solar Power -  MONARCHAK SOLAR POWER STATION",
      link: "/power-generation/solar-power/68",
    },
    {
      name: "Solar Power -   SOLAR TRACKER PLANT KHPS",
      link: "/power-generation/solar-power/17",
    },
  ];

  const getSearchTerm = (term) => {
    setSearchTerm(term);
    if (term !== "") {
      const results = data.filter((item) =>
        item.name.toLowerCase().includes(term.toLowerCase())
      );
      setSearchResults(results);
    } else {
      setSearchResults([]);
    }
  };

  const handleClickSearch = () => {
    setSearchTerm("");
  };

  return (
    <SearchContext.Provider
      value={{
        searchTerm,
        searchResults,
        getSearchTerm,
        handleClickSearch,
        setSearchResults,
        setSearchTerm,
      }}
    >
      {children}
    </SearchContext.Provider>
  );
};

export const useSearch = () => {
  return useContext(SearchContext);
};
